<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书    >  操作指南  >  报考  </div>
    </div>
    <div class="auto padding250">
      <div class="container clearfix">
        <div class="left pull-left">
          <div class="list one">
            <div class="wrap">
               <p class="title">项目经理职业资格证书(见习)</p>

               <router-link to="/renzheng">报考</router-link>
            </div>
          </div>
          <div class="list">
            <div class="wrap">
               <p class="title">项目经理职业资格证书(见习)</p>

               <router-link to="/renzheng">报考</router-link>
            </div>
          </div>
          <div class="list two">
            <div class="wrap">
               <p class="title">项目经理职业资格证书</p>

               <router-link to="/baokao">报考</router-link>
            </div>
          </div>
        </div>
        <div class="right pull-left">
          <p class="title">报考说明</p>
          <p class="desc">准备报名参加项目经理职业资格考试的非在校生学员填写参加考试的基础资料包括：个人基本资料、学历信息、工作经历信息、培训机构信息、培训资格证信息；在校生学员只需填写个人基本资料和学历信息，信息填写完整后需要缴费，缴费完成后提交完成考试报名。</p>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 30px;
      .right{
         width: 405px;
         margin-left: 80px;
      }
      .list{
        border:1px solid #e6e6e6;
        background: url(../../assets/huanzheng.png) no-repeat right bottom;
        margin-bottom: 35px;
        width: 600px;
        &:last-child{
           margin-bottom: 0;
        }
      }
      .two{
        background: url(../../assets/baokao.png) no-repeat right bottom;
      }
      .one{
         background: url(../../assets/baokao1.png) no-repeat right bottom;
      }
      .wrap{
        padding:60px 30px;
        width: 339px;
      }
      .title{
        font-size: 20px;
        color: #000;
        font-weight: 700;
        margin-bottom: 40px;
      }
      .desc{
        font-size: 14px;
        color: #999;
        line-height: 25px;
        margin: 15px 0 20px;
      }
      a{
        color: #fff;
        display: inline-block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #0A3C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/certificate/baokao.vue